// export { BetClass as BlackjackBetClass } from './enums/BetClass';
// export { BetContent as BlackjackBetContent } from './enums/BetContent';
export { BetType as Blackjack2BetType } from './enums/BetType';
// export { Decision as BlackjackDecision } from './enums/Decision';
// export { HistoryInfo as BlackjackHistoryInfo } from './enums/HistoryInfo';
// export type { HistoryInfoKey as BlackjackHistoryInfoKey } from './enums/HistoryInfo';
// export { ResultPlayer as BlackjackResultPlayer } from './enums/ResultPlayer';

export type { GameRecord as Blackjack2Record } from './GameRecord';
export type {
    OwnResult as Blackjack2OwnResult,
    GameResult as Blackjack2Result,
} from './GameResult';

export type {
    GameInfo as Blackjack2GameInfo,
    SeatInfo as Blackjack2SeatInfo,
} from './GameInfo';
export type { HandInfo as Blackjack2HandInfo } from './HandInfo';

// export { createBetResult as createBlackjackBetResult } from './BetResult';
// export type {
//     BetResult as BlackjackBetResult,
//     BetResultKey as BlackjackBetResultKey,
// } from './BetResult';
export type { DecisionType as Blackjack2DecisionType } from './enums/DecisionState';
export type { GameState as Blackjack2GameState } from './enums/GameState';
export type { RecordState as Blackjack2RecordState } from './enums/RecordState';
export type { WinState as Blackjack2WinState } from './enums/WinState';

// export type { History as BlackjackHistory } from './History';
// export type { TotalBet as BlackjackTotalBet } from './TotalBet';
